import { FP } from 'components/financepro';

export const fmtMoney = (v) =>
  (parseFloat(v) || 0).toLocaleString('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const fechaLocalHoy = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const primerDiaMesActual = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}-01`;
};

export const formatearFecha = (fecha) => {
  if (!fecha) return '-';
  try {
    const d = new Date(`${fecha}T00:00:00`);
    return d.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  } catch {
    return fecha;
  }
};

export const formatearFechaLarga = (fecha) => {
  if (!fecha) return '-';
  try {
    const d = new Date(`${fecha}T00:00:00`);
    return d.toLocaleDateString('es-DO', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return fecha;
  }
};

/** Monto contable: negativos entre paréntesis. */
export const fmtMontoContable = (v) => {
  const n = parseFloat(v) || 0;
  const abs = fmtMoney(Math.abs(n));
  return n < 0 ? `(${abs})` : abs;
};

export const textoPeriodoRango = (fechaDesde, fechaHasta) =>
  fechaDesde && fechaHasta
    ? `Del ${formatearFechaLarga(fechaDesde)} al ${formatearFechaLarga(fechaHasta)}`
    : 'Período seleccionado';

export const textoPeriodoCorte = (fechaHasta, fechaDesde) =>
  fechaHasta
    ? `Al ${formatearFechaLarga(fechaHasta)}${
        fechaDesde ? ` · Período desde ${formatearFechaLarga(fechaDesde)}` : ''
      }`
    : 'Fecha de corte seleccionada';

export const cardShellSx = {
  borderRadius: 2.5,
  border: `1px solid ${FP.color.border}`,
  bgcolor: FP.color.cardBg,
  boxShadow: FP.shadow.soft,
  overflow: 'hidden',
};

export const filterHeaderSx = {
  px: { xs: 2, md: 3 },
  py: 1.6,
  borderBottom: `1px solid ${FP.color.border}`,
  bgcolor: '#FAFBFE',
  display: 'flex',
  alignItems: 'center',
  gap: 1.2,
};

export const cellHeadSx = {
  fontWeight: 700,
  fontSize: '0.75rem',
  color: FP.color.textSecondary,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  display: 'block',
  mb: 0.5,
};

export const cellEllipsisSx = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const btnPrimarySx = {
  textTransform: 'none',
  fontWeight: 700,
  borderRadius: 1.4,
  bgcolor: FP.color.navy,
  color: '#FFFFFF',
  boxShadow: 'none',
  '&:hover': { bgcolor: FP.color.navyDeep, boxShadow: 'none' },
  '&.Mui-disabled': { bgcolor: FP.color.border, color: FP.color.textMuted },
};

export const btnOutlinedSx = {
  textTransform: 'none',
  borderRadius: 1.4,
  fontWeight: 700,
  borderColor: FP.color.border,
  color: FP.color.textPrimary,
};
